<bi-dropDown [DropDownList]="data?.Columns" [SelectedRow]="data.value[0].field" [TextField]="'DisplayName'"
    [ValueField]="'Name'" [styleType]="'large'" (OnValueChange)="editorValueChange($event)">
</bi-dropDown>
<div class="mb-2 mt-2"></div>
<mat-radio-group aria-label="Select an option" [(ngModel)]="SortingOrder">
    <mat-radio-button value="asc" class="me-3">{{'Ascending' | translate}}</mat-radio-button>
    <mat-radio-button value="desc">{{'Descending' | translate}}</mat-radio-button>
</mat-radio-group>